import { parseJsonIfValid } from '@salescore/buff-common'
import type { AtomEffect } from 'recoil'
import type { ZodType } from 'zod'

export const localStorageEffect: <T>(key: string, schema: ZodType<T>) => AtomEffect<T> =
  (key, schema) =>
  ({ setSelf, onSet }) => {
    const keyWithPrefix = `recoil/${key}`
    const savedValue = localStorage.getItem(keyWithPrefix)
    if (savedValue !== null) {
      const x = schema.safeParse(parseJsonIfValid(savedValue))
      if (x.success) {
        setSelf(x.data)
      }
    }

    onSet((newValue, _, isReset) => {
      isReset ? localStorage.removeItem(keyWithPrefix) : localStorage.setItem(keyWithPrefix, JSON.stringify(newValue))
    })
  }
